export default __webpack_public_path__ + "static/media/photo--lg--misc-21.63457e3f.jpg";